import BAboutSubscription from './BAboutSubscription'

export default BAboutSubscription
